/** Preset profile avatars under `public/assets/avatars/{astrology,numerology}/`. */

const ASTROLOGY_AVATAR_BASE = '/schools/parashari/assets/avatars/astrology';
const NUMEROLOGY_AVATAR_BASE = '/schools/parashari/assets/avatars/numerology';

export const STUDENT_PROFILE_AVATARS = [
  {
    id: 'mars-warrior-feminine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-mars-warrior-feminine.png`,
    labelEn: 'Mars warrior',
    labelHi: 'मंगल योद्धा',
  },
  {
    id: 'mars-warrior-masculine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-mars-warrior-masculine.png`,
    labelEn: 'Mars sentinel',
    labelHi: 'मंगल रक्षक',
  },
  {
    id: 'mars-warrior-androgynous',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-mars-warrior-androgynous.png`,
    labelEn: 'Mars guardian',
    labelHi: 'मंगल संरक्षक',
  },
  {
    id: 'sun-warrior-feminine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-sun-warrior-feminine.png`,
    labelEn: 'Sun heroine',
    labelHi: 'सूर्य वीरांगना',
  },
  {
    id: 'sun-warrior-masculine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-sun-warrior-masculine.png`,
    labelEn: 'Solar knight',
    labelHi: 'सौर योद्धा',
  },
  {
    id: 'saturn-warrior-feminine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-saturn-warrior-feminine.png`,
    labelEn: 'Saturn sage',
    labelHi: 'शनि योद्धा',
  },
  {
    id: 'saturn-warrior-masculine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-saturn-warrior-masculine.png`,
    labelEn: 'Saturn sentinel',
    labelHi: 'शनि रक्षक',
  },
  {
    id: 'rahu-eclipse-warrior-androgynous',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-rahu-eclipse-warrior-androgynous.png`,
    labelEn: 'Eclipse warrior',
    labelHi: 'ग्रहण योद्धा',
  },
  {
    id: 'ketu-mystic-warrior-feminine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-ketu-mystic-warrior-feminine.png`,
    labelEn: 'Ketu blade-dancer',
    labelHi: 'कetu नर्तक',
  },
  {
    id: 'ketu-mystic-warrior-masculine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-ketu-mystic-warrior-masculine.png`,
    labelEn: 'Ketu spear guardian',
    labelHi: 'कetu रक्षक',
  },
  {
    id: 'zodiac-constellation-warrior-androgynous',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-zodiac-constellation-warrior-androgynous.png`,
    labelEn: 'Constellation champion',
    labelHi: 'नक्षत्र योद्धा',
  },
  {
    id: 'navagraha-guardian-neutral',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-navagraha-guardian-neutral.png`,
    labelEn: 'Navagraha guardian',
    labelHi: 'नवग्रह रक्षक',
  },
  {
    id: 'moon-warrior-feminine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-moon-warrior-feminine.png`,
    labelEn: 'Moon heroine',
    labelHi: 'चंद्र वीरांगना',
  },
  {
    id: 'moon-warrior-masculine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-moon-warrior-masculine.png`,
    labelEn: 'Lunar knight',
    labelHi: 'चंद्र योद्धा',
  },
  {
    id: 'moon-warrior-androgynous',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-moon-warrior-androgynous.png`,
    labelEn: 'Moon guardian',
    labelHi: 'चंद्र संरक्षक',
  },
  {
    id: 'mercury-warrior-feminine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-mercury-warrior-feminine.png`,
    labelEn: 'Mercury scribe',
    labelHi: 'बुध लेखिका',
  },
  {
    id: 'mercury-warrior-masculine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-mercury-warrior-masculine.png`,
    labelEn: 'Mercury swift',
    labelHi: 'बुध योद्धा',
  },
  {
    id: 'mercury-warrior-androgynous',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-mercury-warrior-androgynous.png`,
    labelEn: 'Mercury messenger',
    labelHi: 'बुध दूत',
  },
  {
    id: 'jupiter-warrior-feminine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-jupiter-warrior-feminine.png`,
    labelEn: 'Jupiter priestess',
    labelHi: 'गुरु वीरांगना',
  },
  {
    id: 'jupiter-warrior-masculine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-jupiter-warrior-masculine.png`,
    labelEn: 'Jupiter sage knight',
    labelHi: 'गुरु योद्धा',
  },
  {
    id: 'venus-warrior-feminine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-venus-warrior-feminine.png`,
    labelEn: 'Venus enchantress',
    labelHi: 'शुक्र वीरांगना',
  },
  {
    id: 'venus-warrior-masculine',
    url: `${ASTROLOGY_AVATAR_BASE}/avatar-venus-warrior-masculine.png`,
    labelEn: 'Venus diplomat',
    labelHi: 'शुक्र योद्धा',
  },
  {
    id: 'numero-1-radiant',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-1-radiant.png`,
    labelEn: 'Number 1 · Sun radiant',
    labelHi: 'अंक 1 · सूर्य प्रभा',
  },
  {
    id: 'numero-1-mystic',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-1-mystic.png`,
    labelEn: 'Number 1 · Sun mystic',
    labelHi: 'अंक 1 · सूर्य रहस्य',
  },
  {
    id: 'numero-2-radiant',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-2-radiant.png`,
    labelEn: 'Number 2 · Moon radiant',
    labelHi: 'अंक 2 · चंद्र प्रभा',
  },
  {
    id: 'numero-2-mystic',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-2-mystic.png`,
    labelEn: 'Number 2 · Moon mystic',
    labelHi: 'अंक 2 · चंद्र रहस्य',
  },
  {
    id: 'numero-3-radiant',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-3-radiant.png`,
    labelEn: 'Number 3 · Jupiter radiant',
    labelHi: 'अंक 3 · गुरु प्रभा',
  },
  {
    id: 'numero-3-mystic',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-3-mystic.png`,
    labelEn: 'Number 3 · Jupiter mystic',
    labelHi: 'अंक 3 · गुरु रहस्य',
  },
  {
    id: 'numero-4-radiant',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-4-radiant.png`,
    labelEn: 'Number 4 · Rahu radiant',
    labelHi: 'अंक 4 · राहु प्रभा',
  },
  {
    id: 'numero-4-mystic',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-4-mystic.png`,
    labelEn: 'Number 4 · Rahu mystic',
    labelHi: 'अंक 4 · राहु रहस्य',
  },
  {
    id: 'numero-5-radiant',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-5-radiant.png`,
    labelEn: 'Number 5 · Mercury radiant',
    labelHi: 'अंक 5 · बुध प्रभा',
  },
  {
    id: 'numero-5-mystic',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-5-mystic.png`,
    labelEn: 'Number 5 · Mercury mystic',
    labelHi: 'अंक 5 · बुध रहस्य',
  },
  {
    id: 'numero-6-radiant',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-6-radiant.png`,
    labelEn: 'Number 6 · Venus radiant',
    labelHi: 'अंक 6 · शुक्र प्रभा',
  },
  {
    id: 'numero-6-mystic',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-6-mystic.png`,
    labelEn: 'Number 6 · Venus mystic',
    labelHi: 'अंक 6 · शुक्र रहस्य',
  },
  {
    id: 'numero-7-radiant',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-7-radiant.png`,
    labelEn: 'Number 7 · Ketu radiant',
    labelHi: 'अंक 7 · केतु प्रभा',
  },
  {
    id: 'numero-7-mystic',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-7-mystic.png`,
    labelEn: 'Number 7 · Ketu mystic',
    labelHi: 'अंक 7 · केतु रहस्य',
  },
  {
    id: 'numero-8-radiant',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-8-radiant.png`,
    labelEn: 'Number 8 · Saturn radiant',
    labelHi: 'अंक 8 · शनि प्रभा',
  },
  {
    id: 'numero-8-mystic',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-8-mystic.png`,
    labelEn: 'Number 8 · Saturn mystic',
    labelHi: 'अंक 8 · शनि रहस्य',
  },
  {
    id: 'numero-9-radiant',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-9-radiant.png`,
    labelEn: 'Number 9 · Mars radiant',
    labelHi: 'अंक 9 · मंगल प्रभा',
  },
  {
    id: 'numero-9-mystic',
    url: `${NUMEROLOGY_AVATAR_BASE}/avatar-numero-9-mystic.png`,
    labelEn: 'Number 9 · Mars mystic',
    labelHi: 'अंक 9 · मंगल रहस्य',
  },
];

export const DEFAULT_STUDENT_AVATAR_ID = 'moon-warrior-androgynous';

/** @type {typeof STUDENT_PROFILE_AVATARS[number] | undefined} */
export const DEFAULT_STUDENT_AVATAR = STUDENT_PROFILE_AVATARS.find(
  (avatar) => avatar.id === DEFAULT_STUDENT_AVATAR_ID,
);

export const DEFAULT_STUDENT_AVATAR_URL = DEFAULT_STUDENT_AVATAR?.url ?? null;

const ALLOWED_URLS = new Set(STUDENT_PROFILE_AVATARS.map((a) => a.url));

/** Pre-astrology-folder paths → current canonical URLs. */
const LEGACY_AVATAR_URLS = Object.fromEntries(
  STUDENT_PROFILE_AVATARS.flatMap((avatar) => {
    const filename = avatar.url.split('/').pop();
    return [
      [`/assets/avatars/${filename}`, avatar.url],
      [`/assets/avatars/new/${filename}`, avatar.url],
    ];
  }),
);

/** @param {string | null | undefined} url */
export function normalizeStudentAvatarUrl(url) {
  if (!url) return null;
  const trimmed = url.trim();
  return LEGACY_AVATAR_URLS[trimmed] ?? trimmed;
}

/** Square circular PNG - fill the ring without distortion. */
export const AVATAR_PORTRAIT_IMG_CLASS =
  'aspect-square h-full w-full object-cover object-center';

/**
 * @param {'xs' | 'sm' | 'md' | 'lg' | 'nav'} [_size]
 * @returns {string}
 */
export function getAvatarPortraitImgClass(_size) {
  return AVATAR_PORTRAIT_IMG_CLASS;
}

/** @param {string | null | undefined} url */
export function isAllowedStudentAvatarUrl(url) {
  if (!url) return true;
  return ALLOWED_URLS.has(normalizeStudentAvatarUrl(url));
}

/** True when the URL is a deliberate user choice (not an unset/placeholder default). */
export function isExplicitStudentAvatarChoice(url) {
  const normalized = normalizeStudentAvatarUrl(url);
  return Boolean(
    normalized && isAllowedStudentAvatarUrl(normalized) && normalized !== DEFAULT_STUDENT_AVATAR_URL,
  );
}

/** @param {string | null | undefined} url @returns {string | null} */
export function resolveProfileAvatarUrl(url) {
  const normalized = normalizeStudentAvatarUrl(url);
  if (normalized && ALLOWED_URLS.has(normalized)) return normalized;
  return DEFAULT_STUDENT_AVATAR_URL;
}

/** @param {string | null | undefined} url */
export function getStudentAvatarByUrl(url) {
  if (!url) return null;
  const normalized = normalizeStudentAvatarUrl(url);
  return STUDENT_PROFILE_AVATARS.find((a) => a.url === normalized) ?? null;
}
